<template>
    <transition name="fadeHeight">
        <div class="card-block">
        <div class="alert alert-danger" v-if="message.length > 0" role="alert">
            <button @click="handleCloseAlert" type="button" class="close">
                <span aria-hidden="true">&times;</span>
            </button>
            <div v-for="(msg, idx) in message" :key="idx">
                {{ msg }}
            </div>
        </div>
        </div>
    </transition>
</template>

<script type="text/javascript">

    export default {
        name: 'alert',
        props: {
            message: {
                type: Array,
                default: []
            }
        },
        data() {
            return {}
        },
        methods: {
            handleCloseAlert() {
                this.$emit('clear-alerts');
            }
        }
    };
</script>

<style scoped lang="scss">
    .alert{
        overflow:hidden;
        padding: 9px 20px;
        &.alert-success{
            color: #164220 !important;
            border-color: #b9e8cd !important;
            background: #e6f7ea !important;
        }
        &.alert-danger{
            color: #581c21 !important;
            border-color: #f1d2cc !important;
            background: #fbeaec !important;
        }
        &.alert-info{
            color: #0c7b94 !important;
            border-color: #02a7cd !important;
            background: rgba(206, 245, 255, 0.7) !important;
        }
    }
    .close{
        position: absolute;
        right: 7px;
        top: 2px;
    }
    .fadeHeight-enter-active,
    .fadeHeight-leave-active {
      transition: all 0.2s;
      max-height: 200px;
    }
    .fadeHeight-enter,
    .fadeHeight-leave-to
    {
      opacity: 0;
      max-height: 0px;
    }
</style>